// extracted by mini-css-extract-plugin
module.exports = {"site":"site--pSWKWQdQ","setting":"setting--c3raVwEg"};